export default __webpack_public_path__ + "static/media/1750.e236900f.png";